import { utils, writeFile } from 'xlsx'

// @function: createXlsx
// @param data: array of objects
// @param filename: string
// @param config: object
// more info on config below
// @param config: customColumns: object - (optional) key is the key of the object in the array, value is an object with label and  custom width
// @param config:
// @param config: sheetName: string
// @param config: sheetHeader: array of strings
// @returns: void
// @description: creates a xlsx file from data and downloads it

export function createXlsx(data, filename, config = {}) {
  if (!data || data.length === 0) {
    throw Error('No data found')
  }
  // Default config
  // if no headers are provided, use the keys of the first object in the array
  const { customColumns = {}, defaultColWidth = 35, sheetName = 'Sheet1' } = config
  const customColsWidths = []
  Object.keys(data[0]).forEach((key) => {
    const len = customColumns[key]?.width || defaultColWidth
    customColsWidths.push({ wch: len })
  })
  // loop through sheet data
  const sheetData = data.map((plan) => {
    const mappedPlan = {}

    for (const key in plan) {
      if (Object.prototype.hasOwnProperty.call(plan, key)) {
        const customName = customColumns[key]?.label || key
        mappedPlan[customName] = plan[key]
      }
    }
    return mappedPlan
  })

  const sheet = utils.json_to_sheet(sheetData)
  sheet['!cols'] = customColsWidths
  const workbook = utils.book_new()
  utils.book_append_sheet(workbook, sheet, sheetName)
  writeFile(workbook, filename)
}
